<div class="flex ninety-dialog-header choose-calendar-provider-header">
  <h1 class="terra-title" data-cy="choose-calendar-provider-dialog_title">Connect your calendar</h1>
  <ninety-button
    flat
    icon
    ariaLabel="Close dialog"
    (click)="cancel()"
    data-cy="choose-calendar-provider-dialog_close-button">
    <terra-icon icon="x" size="20" />
  </ninety-button>
</div>

<p class="text-light dialog-subtext" data-cy="choose-calendar-provider-dialog_subtext">
  Keep this meeting in sync with your calendar. Choose a provider to connect.
</p>
<div class="provider-list" data-cy="choose-calendar-provider-dialog_provider-list">
  @for (integration of sortedIntegrations(); track integration.id) {
    <div class="provider-row" [attr.data-cy]="'choose-calendar-provider-dialog_row-' + integration.id">
      <div class="provider-info">
        <img class="provider-logo" [src]="integration.logoUrl" [alt]="integration.displayName" />
        <span class="provider-name">{{ integration.displayName }}</span>
      </div>
      <ninety-button
        stroked
        [disabled]="connectingIntegrationId() === integration.id"
        (click)="connect(integration)"
        [attr.data-cy]="'choose-calendar-provider-dialog_connect-' + integration.id">
        {{ connectingIntegrationId() === integration.id ? 'Connecting...' : 'Connect' }}
      </ninety-button>
    </div>
  }
</div>
